import { Divider } from "antd";

const AuthOrDivider = ({ title }) => (
  <Divider orientation="center" plain>
    <span className="text-gray-500 text-sm">{title}</span>
  </Divider>
);

export default AuthOrDivider;
